import {APP_KEY,HTTP_URL} from "../../../util/constants";

//获取用户列表
export function getGuangdongnengListRequest(callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'get_guangdongneng_list');

  return fetch(HTTP_URL+'Chongzhi/i',{
    method: 'post',
    body: formData,
  }).then(function (res) {
    return res.json();
  }).then(function (json) {
    callback && callback(json);
  }).catch(e => {
    console.error(e);
    callback && callback(e);

  });
}
//添加用户
export function addGuangdongnengRequest(price,fixedPoints,presentPoint,remark,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'add_guangdongneng');
  formData.append("jiage",price);
  formData.append("guding_jifen", fixedPoints);//(不选传空字符串，1:正常 2：删除 3：禁用)
  formData.append("zengsong_jifen", presentPoint);
  formData.append("zongjifen", parseInt(fixedPoints) + parseInt(presentPoint));
  formData.append("beizhu", remark);

  return fetch(HTTP_URL+'Chongzhi/i',{
    method: 'post',
    body: formData,
  }).then(function (res) {
    return res.json();
  }).then(function (json) {
    callback && callback(json);
  }).catch(e => {
    console.error(e);
    callback && callback(e);

  });
}
//删除用户
export function delPointRequest(id,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'del_guangdongneng');
  formData.append("Id",id);

  return fetch(HTTP_URL+'Chongzhi/i',{
    method: 'post',
    body: formData,
  }).then(function (res) {
    return res.json();
  }).then(function (json) {
    callback && callback(json);
  }).catch(e => {
    console.error(e);
    callback && callback(e);

  });
}
//禁用、启用用户
export function shouquanPointRequest(status,Id,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'update_guangdongneng_status');
  formData.append("Id",Id);
  formData.append("status",status);//(1:启用，2：禁用)；

  return fetch(HTTP_URL+'Chongzhi/i',{
    method: 'post',
    body: formData,
  }).then(function (res) {
    return res.json();
  }).then(function (json) {
    callback && callback(json);
  }).catch(e => {
    console.error(e);
    callback && callback(e);

  });
}
//编辑用户
export function editPointRequest(price,fixedPoints,presentPoint,remark,Id,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'update_guangdongneng');
  formData.append("jiage",price);
  formData.append("guding_jifen", fixedPoints);//(不选传空字符串，1:正常 2：删除 3：禁用)
  formData.append("zengsong_jifen", presentPoint);
  formData.append("zongjifen", parseInt(fixedPoints) + parseInt(presentPoint));
  formData.append("beizhu", remark);
  formData.append("Id", Id);

  return fetch(HTTP_URL+'Chongzhi/i',{
    method: 'post',
    body: formData,
  }).then(function (res) {
    return res.json();
  }).then(function (json) {
    callback && callback(json);
  }).catch(e => {
    console.error(e);
    callback && callback(e);

  });
}
